import React, { useCallback, useContext, useMemo } from 'react';
import moment from 'moment';
import RadioButton from 'common/components/RadioButton';
import { ContextType as DashboardContextType, DashboardContext } from 'contexts/DashboardContext';

const Slots: React.FC = () => {
  const { slots = [], setCurrentSlot, currentSlot } =
    useContext<DashboardContextType>(DashboardContext);

  const sortedSlots = useMemo(() => {
    return [...slots].sort(
      (slotA, slotB) =>
        new Date(slotA.starts_at).getTime() - new Date(slotB.starts_at).getTime(),
    );
  }, [slots]);

  const slotsById = useMemo(() => {
    return sortedSlots.reduce((acc, slot) => acc.set(slot.id, slot), new Map());
  }, [sortedSlots]);

  const onClick = useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, id: number) => {
      const selectedSlot = slotsById.get(id);
      if (selectedSlot) {
        setCurrentSlot(selectedSlot);
      }
    },
    [slotsById, setCurrentSlot],
  );

  return (
    <div className="flex flex-col">
      {sortedSlots.map((slot) => (
        <div
          key={slot.id}
          className="flex flex-row justify-between items-center w-full p-1 hover:cursor-pointer"
        >
          <div className="flex flex-col w-full">
            <div className="text-[12px] font-semibold">{slot.event.name}</div>
            <div className="text-[10px]">
              {moment(slot.starts_at).format('hh:mm A')} - {moment(slot.ends_at).format('hh:mm A')}
            </div>
          </div>
          <RadioButton
            id={slot.id}
            name={slot.event.name}
            size="sm"
            onChange={onClick}
            checked={slot.id === currentSlot.id}
            disabled={false}
          />
        </div>
      ))}
    </div>
  );
};

export default Slots;
